<template>
  <div class="apply-page">
    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <h1 class="title">申请加入联盟</h1>
    </div>

    <!-- 步骤条 -->
    <div class="step-bar">
      <div class="step-item active">
        <div class="step-circle">1</div>
        <span>身份选择</span>
      </div>
      <div class="line"></div>
      <div class="step-item">
        <div class="step-circle">2</div>
        <span>填写信息</span>
      </div>
      <div class="line"></div>
      <div class="step-item">
        <div class="step-circle">3</div>
        <span>{{ selectedType === 'personal' ? '提交审核' : '支付确认' }}</span>
      </div>
    </div>

    <!-- 身份选择标题 -->
    <div class="section-title">请选择您的身份类型</div>

    <!-- 企业用户卡片 -->
    <div
      class="identity-card"
      :class="{ active: selectedType === 'enterprise' }"
      @click="selectedType = 'enterprise'"
    >
      <div class="card-icon enterprise">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2">
          <path d="M3 21h18"></path>
          <path d="M5 21V7l8-4v18"></path>
          <path d="M19 21V11l-6-4"></path>
          <path d="M9 9v.01"></path>
          <path d="M9 12v.01"></path>
          <path d="M9 15v.01"></path>
          <path d="M9 18v.01"></path>
        </svg>
      </div>
      <div class="card-content">
        <h3 class="card-title">企业用户</h3>
        <p class="card-desc">适用短剧产业相关企业等</p>
        <div class="card-tips">
          <div class="tip-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#165DFF" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
            </svg>
            <span>需提供营业执照</span>
          </div>
          <div class="tip-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#165DFF" stroke-width="2">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
              <path d="M16 3H6a2 2 0 0 0-2 2v2h16V5a2 2 0 0 0-2-2z"></path>
            </svg>
            <span>需支付认证费进行认证</span>
          </div>
        </div>
      </div>
      <div class="check-mark">
        <svg v-if="selectedType === 'enterprise'" width="20" height="20" viewBox="0 0 24 24" fill="#fff">
          <circle cx="12" cy="12" r="12" fill="#165DFF"/>
          <polyline points="6 12 10 16 18 8" stroke="#fff" stroke-width="2" fill="none"/>
        </svg>
        <div v-else class="radio-circle"></div>
      </div>
    </div>

    <!-- 个人用户卡片 -->
    <div
      class="identity-card"
      :class="{ active: selectedType === 'personal' }"
      @click="selectedType = 'personal'"
    >
      <div class="card-icon personal">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      </div>
      <div class="card-content">
        <h3 class="card-title">全民创演（个人)</h3>
        <p class="card-desc">适用于新大众文艺爱好者</p>
        <div class="card-tips">
          <div class="tip-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#faad14" stroke-width="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="14" y1="2" x2="14" y2="6"></line>
              <line x1="10" y1="2" x2="10" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            <span>免费加入，无需支付认证费用</span>
          </div>
          <div class="tip-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#faad14" stroke-width="2">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
            </svg>
            <span>可申请参与联盟各地全民创演中心活动</span>
          </div>
        </div>
      </div>
      <div class="check-mark">
        <div class="radio-circle" :class="{ checked: selectedType === 'personal' }"></div>
      </div>
    </div>

    <div class="agreement-card" @click="contractChecked = !contractChecked">
      <div class="agreement-check" :class="{ checked: contractChecked }">
        <span v-if="contractChecked">✓</span>
      </div>
      <div class="agreement-text">
        我已阅读并同意
        <a href="javascript:;" @click.stop.prevent="openContract">《粤港澳微短剧产业联盟合同》</a>
      </div>
    </div>

    <!-- 下一步按钮 -->
    <button class="next-btn" :class="{ disabled: !contractChecked }" @click="goNext">
      下一步，填写信息 →
    </button>
  </div>
</template>

<script>
import { getApplyRoute } from '@/utils/memberStatus'

export default {
  name: 'ApplyJoin',
  data() {
    return {
      selectedType: 'enterprise', // 默认选中企业用户
      contractChecked: false
    }
  },
  mounted() {
    this.$ajax.get('/api/user/current').then(res => {
      if (res.data.code !== 200) {
        const target = getApplyRoute(JSON.parse(sessionStorage.getItem('userInfo') || '{}'))
        if (target) this.$router.replace(target)
        return
      }
      const user = res.data.data || {}
      sessionStorage.setItem('userInfo', JSON.stringify(user))
      const target = getApplyRoute(user)
      if (target) this.$router.replace(target)
    }).catch(() => {
      const target = getApplyRoute(JSON.parse(sessionStorage.getItem('userInfo') || '{}'))
      if (target) this.$router.replace(target)
    })
  },
  methods: {
    openContract() {
      this.$router.push('/apply/contract')
    },
    goNext() {
      if (!this.contractChecked) {
        this.$toast.error('请先阅读并同意合同内容')
        return
      }
      this.$store.commit('SET_MEMBER_TYPE', this.selectedType)
      this.$store.commit('SET_STEP1_DATA', {
        formData: {},
        areaInfo: { name: '', id: '' },
        previewImg: '',
        previewImg2: ''
      })
      this.$router.push('/apply/second')
    }
  }
}
</script>

<style scoped>
.apply-page {
  background-color: #f8fafc;
  min-height: 100vh;
  padding-bottom: 80px;
  font-size: 12px;
}

/* 顶部导航 */
.top-nav {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: #fff;
}
.back-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
.title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 auto;
}

/* 步骤条 */
.step-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 20px;
  background: #fff;
  font-size: 10px;
}
.step-item {
  display: flex;
  align-items: center;
  color: #999;
}
.step-item.active {
  color: #165DFF;
}
.step-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #e5e7eb;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  margin-right: 6px;
}
.step-item.active .step-circle {
  background: #165DFF;
  color: #fff;
}
.step-bar .line {
  width: 25px;
  height: 1px;
  background: #e5e7eb;
  margin: 0 8px;
}
.step-bar .line:nth-child(2) {
  background: #165DFF;
}

/* 标题 */
.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  padding: 24px 20px 16px;
}

/* 身份卡片 */
.identity-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  margin: 0 20px 16px;
  display: flex;
  align-items: flex-start;
  border: 2px solid #e5e7eb;
  transition: all 0.2s;
}
.identity-card.active {
  border-color: #165DFF;
  box-shadow: 0 4px 12px rgba(22, 93, 255, 0.15);
}
.card-icon {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  flex-shrink: 0;
}
.card-icon.enterprise {
  background: linear-gradient(135deg, #4080ff, #165DFF);
}
.card-icon.personal {
  background: linear-gradient(135deg, #ffb020, #fa8c16);
}
.card-content {
  flex: 1;
}
.card-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 6px;
}
.card-desc {
  font-size: 12px;
  color: #666;
  margin: 0 0 16px;
}
.card-tips {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.tip-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #666;
}
.check-mark {
  flex-shrink: 0;
  margin-top: 12px;
}
.radio-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid #d1d5db;
}
.radio-circle.checked {
  border-color: #165DFF;
  background: #165DFF;
  position: relative;
}
.radio-circle.checked::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 12px;
  font-weight: bold;
}

.agreement-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 8px 20px 0;
  padding: 14px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
}
.agreement-check {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  margin-top: 1px;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
}
.agreement-check.checked {
  border-color: #165DFF;
  background: #165DFF;
}
.agreement-text {
  flex: 1;
  color: #4b5563;
  font-size: 12px;
  line-height: 1.6;
}
.agreement-text a {
  color: #165DFF;
}

/* 下一步按钮 */
.next-btn {
  width: calc(100% - 40px);
  margin: 32px 20px 0;
  background: #165DFF;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 16px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(22, 93, 255, 0.3);
}
.next-btn.disabled {
  background: #bcd7ff;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/join/first.vue